import { Component } from '@angular/core';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';

@Component({
  selector: '',
  templateUrl:
    'console/app-js/modules/bulkAdd/shared/please-check-grid-dialog/please-check-grid-dialogue.component.html'
})
export class PleaseCheckData {
  constructor(public activeDialog: UIActiveDialogService) {}

  /**
   * TODO: document this.
   */
  protected okButton() {
    this.activeDialog.close(true);
  }

  /**
   * TODO: document this.
   */
  protected cancelCloseButton(): void {
    this.activeDialog.dismiss();
  }
}
